import { periods, plan_types } from '@public/components/signup_page/plan/plans'
import ModalPanel from '@admin/components/modal_panel'
import Message from '@admin/components/message'
import PropTypes from 'prop-types'
import Plan from './plan'
import React from 'react'

class ChangePlan extends React.Component {

  static contextTypes = {
    admin: PropTypes.object
  }

  static propTypes = {
    formdata: PropTypes.object,
    props: PropTypes.object,
    onBack: PropTypes.func,
    onCancel: PropTypes.func,
    onChange: PropTypes.func,
    onNext: PropTypes.func,
    onSave: PropTypes.func
  }

  state = {
    period: null,
    plan_type: null
  }

  _handleBack = this._handleBack.bind(this)
  _handleSave = this._handleSave.bind(this)

  render() {
    const { subscription } = this.props.props
    const { current_period, next_period } = subscription
    const { period } = this.state
    if(!period) return null
    if(current_period.plan.id !== next_period.plan.id) return <Message { ...this._getWait() } />
    const sliderClass = 'maha-manage-plan-periods-slider' + (current_period.frequency.units === 'year' ? ' yearly' : '')
    const { admin } = this.context
    const entity_type = admin.advisor !== null ? 'advisor' : 'agency'
    console.log(plan_types[entity_type].filter(plan_type => plan_type.value !== 'website'))
    return (
      <ModalPanel { ...this._getPanel() }>
        <div className="maha-manage-plan">
          <div className="maha-manage-plan-periods">
            <div className={sliderClass} aria-hidden="true" />
            { periods.map((period,index) => (
              <div { ...this._getPeriod(period) } key={`period_${index}`} style={{ position: 'relative', zIndex: 2 }}>{ period.title }</div>
            )) }
          </div>
          <div className="maha-manage-plan-plans-outer">
            <div className="maha-manage-plan-plans-container">
              <div className="maha-manage-plan-plans">
                { plan_types[entity_type].filter(plan_type => plan_type.value !== 'website').map((plan_type, index) => (
                  <Plan { ...this._getPlan(plan_type) } key={index} />
                )) }
              </div>
            </div>
          </div>
        </div>
      </ModalPanel>
    )
  }

  componentDidMount() {
    const { props } = this.props
    const { subscription } = props
    this.setState({
      period: subscription.next_period.frequency.units === 'year' ? 'yearly' : 'monthly',
      plan_type: subscription.next_period.plan.title.toLowerCase().includes('pro') ? 'pro' : 'essentials'
    })
  }

  _getPanel() {
    return {
      showHeader: false,
      buttons: [
        { label: 't(Previous)', color: 'blue', basic: true, handler: this._handleBack },
        { label: 't(Finish)', color: 'blue', handler: this._handleSave }
      ]
    }
  }

  _getPlan(plan_type) {
    const { plans } = this.props.props
    const { period } = this.state
    console.log({ plan_type, plans, period })
    return {
      is_chosen: plan_type.value === this.state.plan_type,
      period,
      plan_type,
      plan: plans[plan_type.value][period],
      onChoose: this._handlePlanType.bind(this, plan_type.value)
    }
  }

  _getPeriod(period) {
    return {
      className: this._getPeriodClass(period.value),
      onClick: this._handlePeriod.bind(this, period.value)
    }
  }

  _getPeriodClass(value) {
    const { period } = this.state
    const classes = ['maha-manage-plan-period']
    if(period === value) classes.push('selected')
    return classes.join(' ')
  }

  _getWait() {
    const { onCancel } = this.props
    return {
      title: 't(Plan Change Scheduled)',
      text: 't(You have already scheduled a plan change. You can change it again once the current period ends. If you need to change it sooner, please contact support@truevail.com)',
      svg: 'clock',
      button: {
        label: 't(Done)',
        handler: onCancel
      }
    }
  }

  _handleBack() {
    this.props.onBack()
  }

  _handlePeriod(period) {
    this.setState({ period })
  }

  _handlePlanType(plan_type) {
    this.setState({ plan_type })
  }

  _handleSave() {
    const { period, plan_type } = this.state
    const { plans } = this.props.props
    this.props.onSave({
      plan_id: plans[plan_type][period].id
    })
  }
  
}

export default ChangePlan